<app-dialog-container>
  <mat-dialog-content class="dialogContent">
    <h1 mat-card-title>{{ title }}</h1>

    <div class="user-perm-body" data-testid="user-permissions">
      <app-permission-selector
        [catalog]="permissionCatalog"
        [permissions]="permissionsForSelector"
        [selectedIds]="selectedIds"
        [loading]="permissionsLoading"
        [frontFirstGroups]="frontFirstGroups"
        [frontFirstLoading]="frontFirstLoading"
        (selectedIdsChange)="onSelectedIdsChange($event)">
      </app-permission-selector>
    </div>
  </mat-dialog-content>

  <app-dialog-save-close
    closeText="SAIR"
    saveText="APLICAR"
    [closeOnSave]="false"
    (onSave)="confirm()"
  ></app-dialog-save-close>
</app-dialog-container>
